export default "__VITE_ASSET__Bzmu_314__"